module.exports = __webpack_public_path__ + "static/img/bg_blur04.ba88a392.jpg";